import { ClipboardButton, Code } from '@neo4j-ndl/react';
import React from 'react';

type LanguageProp = 'text' | 'cypher' | 'json';
interface SingleLineCodeBlockProps extends React.ComponentProps<'div'> {
  code: string;
  language?: LanguageProp;
  copyButton?: boolean;
}

export const SingleLineCodeBlock = ({ code, language = 'text', copyButton = true }: SingleLineCodeBlockProps) => {
  return (
    <div className="group relative">
      <Code language={language} code={code} className="min-h-0 w-full" />
      {copyButton && (
        <div className="absolute right-1 top-1 opacity-0 transition-opacity group-hover:opacity-100">
          <ClipboardButton textToCopy={code} tooltipProps={{ isPortaled: false, type: 'simple', placement: 'left' }} />
        </div>
      )}
    </div>
  );
};
